export enum propertyType {
  House = "Casa",
  Apartment = "Departamento",
  Lot = "Terreno",
  Studio = "Estudio",
  Local = "Local",
  Warehouse = "Bodega",
}

export enum ubications {
  Cancun = "Cancún",
  Merida = "Mérida",
  "Playa del Carmen" = "Playa del Carmen",
  "Puerto Morelos" = "Puerto Morelos",
  Tulum = "Tulum",
  "Ciudad Sahagún" = "Ciudad Sahagún",
}

export enum businessType {
  Sale = "Venta",
  Rent = "Renta",
  VacationalRent = "Renta Vacacional",
}
export interface PropertyFeatures {
  [key: string]: string;
}

export interface PropertyInfo {
  titulo: string;
  direccion: string;
  imagenes: File[];
  imagenesURLs: string[];
  habitaciones: number;
  banos: number;
  tipoDePropiedad: propertyType;
  descripcion: string;
  caracteristicas: PropertyFeatures;
  terreno: string;
  estacionamiento: string;
  construccion: string;
  precio: number;
  latitud: string;
  longitud: string;
  ciudad: ubications;
  anoDeConstruccion: string;
  tipoDeNegocio: businessType;
}

export const propertyInfoDefault: PropertyInfo = {
  titulo: "",
  direccion: "",
  imagenes: [],
  imagenesURLs: [],
  habitaciones: 0,
  banos: 0,
  tipoDePropiedad: propertyType.House,
  descripcion: "",
  caracteristicas: {} as PropertyFeatures,
  terreno: "",
  estacionamiento: "",
  construccion: "",
  precio: 0,
  latitud: "",
  longitud: "",
  ciudad: ubications.Cancun,
  anoDeConstruccion: "",
  tipoDeNegocio: businessType.Sale,
};